import { connectionContextToDevice } from './rock5aConnectionContext.js'

export class Rock5aConnectionCoordinator {
  constructor(options) {
    this.contextStore = options.contextStore
    this.gesture = options.gesture
    this.voice = options.voice
    this.connectAssistant = options.connectAssistant
    this.disconnectAssistant = options.disconnectAssistant
    this._activeContext = null
    this._transition = Promise.resolve()
  }

  connect(context) {
    this._transition = this._transition.then(async () => {
      if (!context) throw new Error('rock5a_connection_context_required')
      if (this._activeContext && this._activeContext.deviceId === context.deviceId
        && this._activeContext.host === context.host
        && this._activeContext.controlPort === context.controlPort
        && this._activeContext.audioPort === context.audioPort
        && this._activeContext.controlWsUrl === context.controlWsUrl) return context

      await this._disconnectCurrent()
      this.contextStore.updateConnectionState('connecting')
      const device = connectionContextToDevice(context)
      try {
        this.gesture.connect(context, device)
        this.voice.connect(context, device)
        await this.connectAssistant(context)
        this._activeContext = context
        this.contextStore.updateConnectionState('connected', { connectedAt: new Date().toISOString() })
        return context
      } catch (error) {
        this.contextStore.updateConnectionState('error')
        await this._disconnectCurrent()
        throw error
      }
    })
    return this._transition
  }

  disconnect() {
    this._transition = this._transition.then(async () => {
      await this._disconnectCurrent()
      this.contextStore.updateConnectionState('disconnected')
    })
    return this._transition
  }

  async _disconnectCurrent() {
    this.disconnectAssistant()
    if (this.voice) this.voice.disconnect()
    if (this.gesture) this.gesture.disconnect()
    this._activeContext = null
  }
}

